module.exports = __webpack_public_path__ + "static/6-283d6ef5ad3d5fc1cf4f83b121a15abc.jpeg";